import { Injectable } from '@angular/core';

/**
 * Handles modal interactions.
 */
@Injectable({
  providedIn: 'root'
})
export class EventAdministrationService {
  public listOfModals: any = {
    editLotteryDetailsModalOpened: false,
    editProcessConfigurationModalOpened: false,
    editWebpageIndividualizationModalOpened: false,
    editPriceCategoriesModalOpened: false,
    createPriceCategoriesModalOpened: false,
    createPriceReductionsModalOpened: false,
    editPriceReductionsModalOpened: false,
    editTicketQuotaModalOpened: false,
    editAssignedReductionsModalOpened: false,
    editSpecialRequirementModalOpened: false,
  };

  public loadingSubmitClicked: boolean = false;

  constructor() { }

  /**
   * Set the status to all modals.
   */
  public toggleAllModal(status: boolean): any {
    this.toggleEditLotteryDetailsModal(status);
    this.toggleEditProcessConfigurationModal(status);
    this.toggleEditWebpageIndividualizationModal(status);
    this.toggleEditPriceCategoriesModal(status);
    this.toggleCreatePriceCategoriesModal(status);
    this.toggleCreatePriceReductionsModal(status);
    this.toggleEditPriceReductionsModal(status);
    this.toggleEditTicketQuotaModal(status);
    this.toggleEditAssignedReductionsModal(status);
    this.toggleEditSpecialRequirementModal(status);
  }

  /**
   * Set the status of the edit lottery details modal.
   */
  public toggleEditLotteryDetailsModal(status: boolean): void {
    this.listOfModals.editLotteryDetailsModalOpened = status;
  }

  /**
   * Set the status of the edit configuration modal.
   */
  public toggleEditProcessConfigurationModal(status: boolean): void {
    this.listOfModals.editProcessConfigurationModalOpened = status;
  }

  /**
   * Set the status of the edit webpage individualization modal.
   */
  public toggleEditWebpageIndividualizationModal(status: boolean): void {
    this.listOfModals.editWebpageIndividualizationModalOpened = status;
  }

  /**
   * Set the status of the edit price categores modal.
   */
  public toggleEditPriceCategoriesModal(status: boolean): void {
    this.listOfModals.editPriceCategoriesModalOpened = status;
  }

  /**
   * Set the status of the edit price categores modal.
   */
  public toggleEditAssignedReductionsModal(status: boolean): void {
    this.listOfModals.editAssignedReductionsModalOpened = status;
  }

  /**
   * Set the status of the create categories modal.
   */
  public toggleCreatePriceCategoriesModal(status: boolean): void {
    this.listOfModals.createPriceCategoriesModalOpened = status;
  }

  /**
   * Set the status of the create reductions modal.
   */
  public toggleCreatePriceReductionsModal(status: boolean): void {
    this.listOfModals.createPriceReductionsModalOpened = status;
  }

  /**
   * Set the status of the edit reductions modal.
   */
  public toggleEditPriceReductionsModal(status: boolean): void {
    this.listOfModals.editPriceReductionsModalOpened = status;
  }

  /**
   * Set the status of the edit ticket quota modal.
   */
  public toggleEditTicketQuotaModal(status: boolean): void {
    this.listOfModals.editTicketQuotaModalOpened = status;
  }

  /**
   * Set the status of the edit ticket quota modal.
   */
   public toggleEditSpecialRequirementModal(status: boolean): void {
    this.listOfModals.editSpecialRequirementModalOpened = status;
  }

}
